<template>
	<core-layout-content full>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("insurers") }}</template>
			<template slot="actions">
				<j-button v-can="'writeProducts'" :to="{ name: 'InsurersCreate' }">
					<crm-icon name="add" size="small" color="c5" />
					{{ $t("create_insurer") }}
				</j-button>
			</template>
		</core-layout-headline-and-actions>

		<j-card class="bg5">
			<j-data-table
				:header="header"
				:list="computedList"
				:sortable="false"
				:isLoading="isLoading"
				@sort="onSort($event)"
			>
				<template slot="list" slot-scope="{ item }">
					<td v-for="(column, i) in header" :key="i">
						<template>
							<!-- Name -->
							<template v-if="column.field === 'name'">
								<router-link
									:to="{
										name: `InsurersUpdate`,
										params: {
											id: item.id
										}
									}"
									>{{ item.name }}</router-link
								>
							</template>

							<!-- Others -->
							<template v-else>{{ item[column.field] }}</template>

							<!-- Actions -->
							<template
								v-if="column.field === 'actions' && item.tenantId !== 'default'"
							>
								<div class="action">
									<!-- Delete -->
									<crm-icon
										name="delete"
										size="normal"
										color="cError"
										@click.native="showModal(item.id)"
										v-can="'writeInsurers'"
									/>
								</div>
							</template>
						</template>
					</td>
				</template>
				<template slot="empty">{{ $t("errors.no_data") }}</template>
			</j-data-table>
		</j-card>

		<!-- Delete confirmation modal -->
		<j-dialog
			:height="200"
			:width="600"
			:title="$t('delete')"
			type="delete"
			@confirm="onRemove(selectedItemId)"
			>{{ $t("errors.are_you_sure_you_want_to_delete_insurer") }}</j-dialog
		>
	</core-layout-content>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import JDialog from "@/components/JDialog/"
import dayjs from "dayjs"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		CrmIcon,
		JButton,
		JCard,
		JDataTable,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		JDialog
	},

	data() {
		return {
			isLoading: false,

			listing: {
				list: []
			},
			// Header of table
			header: [
				{
					field: "name",
					text: this.$t("name")
				},
				{
					field: "detailedName",
					text: this.$t("detailedName")
				},
				{
					field: "id",
					text: this.$t("id")
				},
				{
					text: this.$t("created"),
					field: "createdAt"
				},
				{
					text: this.$t("actions"),
					field: "actions"
				}
			],

			selectedItemId: ""
		}
	},

	computed: {
		/**
		 * Compute fetch data for data table
		 * This is what we are gonna display
		 */
		computedList() {
			return this.listing.list.map(item => ({
				name: item.name,
				detailedName: item.detailedName,
				id: get(item, "id"),
				createdAt: item.createdAt
					? dayjs(item.createdAt).format(
							this.$store.state.settings.dateTimeFormat
					  )
					: null
			}))
		}
	},

	methods: {
		async readAll() {
			this.isLoading = true
			const res = await api.insurers()
			this.isLoading = false

			this.listing.list = res.data.insurers
		},

		showModal(id) {
			this.selectedItemId = id
			this.$modal.show("j-dialog")
		},

		hideModal() {
			this.selectedItemId = null
			this.$modal.hide("j-dialog")
		},

		async onRemove(id) {
			await api.deleteInsurer({ id })
			this.hideModal()
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("insurer_deleted")
				}
			})
			this.readAll()
		}
	},

	mounted() {
		this.readAll()
	}
}
</script>
